export default __webpack_public_path__ + "img/139cff5dd27bcda6a175b286becb692c.svg";